import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import DatePicker from "react-datepicker";
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import moment from "moment/moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import CircularProgress from "@mui/material/CircularProgress";

const QuestionWiseDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { qid, question, bid, sDate, eDate } = location.state || {};
  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const [feedbackStats, setFeedbackStats] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [mobileNo, setMobileNo] = useState("");
  const [kioskId, setKioskId] = useState("");

  const [list, setList] = useState([]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [sort, setSort] = useState({ name: "", direction: "" });

  useEffect(() => {
    setStartDate(sDate);
    setEndDate(eDate);
  }, [sDate, eDate]);

  useEffect(() => {
    fetchData(page, rowsPerPage);
  }, [
    page,
    rowsPerPage,
    sort,
    startDate,
    endDate,
    searchText,
    kioskId,
    mobileNo,
  ]);

  const fetchData = (page, rowsPerPage) => {
    console.info("question: ", question);

    setIsLoading(true);
    axios({
      method: "POST",
      url: `${baseUrl}/feedback/dashboard/question-wise-feedbacks`,
      headers: { Authorization: token },
      data: {
        branchId: bid || userDetails?.bid,
        question: question?.trim() || null,
        size: rowsPerPage,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
        page: page,
        sort: sort,
        searchText: searchText,
        mobile: mobileNo,
        kiosk: kioskId,
      },
    })
      .then((res) => {
        setList(res.data.data.feedbackAnswers);
        setCount(res.data.data.totalFeedbacks);
        setFeedbackStats(res.data.data);
      })
      .catch((error) => {
        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.data, {
            position: 'bottom-center',
          });
        } else {
          toast.remove();
          toast.error('Something went wrong', {
            position: 'bottom-center',
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const columns = [
    {
      label: "Image",
      name: "image",
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          if (list === undefined) return;
          let item = list.find((item, i) => i === dataIndex);

          return <h5 className="py-1">{item.image}</h5>;
        },
      },
    },
    { label: "Mobile No.", name: "mobileNo" },
    {
      label: "Kiosk",
      name: "kiosk",
      options: {
        sort: true,
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          if (list === undefined) return;
          let item = list.find((item, i) => i === dataIndex);

          return <p className="">{item.kiosk || "-"}</p>;
        },
      },
    },
    {
      label: "Branch",
      name: "branch",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Date",
      name: "givenDate",
      options: {
        sort: false,
        filter: false,
      },
    },
  ];

  const options = {
    tableBodyHeight: "52vh",
    filterType: "dropdown",
    filter: false,
    responsive: "vertical",
    serverSide: true,
    count: count,
    download: false,
    jumpToPage: true,
    selectableRows: "none",
    print: false,
    rowsPerPage: rowsPerPage,
    search: false,
    rowsPerPageOptions: [10, 20, 30, 50, 100],
    setTableProps: () => {
      return {
        size: "small",
      };
    },
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setPage(tableState.page);
      } else if (action === "changeRowsPerPage") {
        setRowsPerPage(tableState.rowsPerPage);
        setPage(0);
      } else if (action === "sort") {
        setSort(tableState.sortOrder);
      } else if (action === "search") {
        setSearchText(tableState.searchText);
      }
    },
  };

  const chartOptions = {
    chart: { width: 450, type: "donut" },
    colors: ["#6a5acd", "#9370db", "#8a2be2", "#4169e1", "#4682b4"],
    labels: feedbackStats?.imojies || [],
    legend: {
      position: "bottom",
      fontSize: "19px",
    },
    tooltip: {
      style: {
        fontSize: "16px",
      },
    },
  };

  const series = feedbackStats?.counts || [];

  return (
    <>
      <Toaster />
      <div className="block-header block-header-padding d-flex align-items-center">
        <i
          className="fa fa-arrow-left cursor-pointer mx-3"
          onClick={() =>
            navigate("/feedback-dashboard", {
              state: { sDate: sDate, eDate: eDate },
            })
          }
        ></i>
        {/* <h1>Question-wise Feedback Dashboard</h1> */}
        <h1>{question}</h1>
      </div>
      <div className="container-fluid branch-dashboard mt-4">
        <div className="row clearfix">
          <div className="col-lg-4 col-md-12 col-sm-12 p-l-5 p-r-10">
            <div className="card">
              <div className="body">
                <h6 className="w-100 text-center">Total feedbacks</h6>
                <h4 className="w-100 text-center mb-4">
                  {feedbackStats?.totalFeedbacks}
                </h4>
                <ReactApexChart
                  options={chartOptions}
                  series={series}
                  type="donut"
                  height="350px"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-12 col-sm-12 p-l-5 p-r-10">
            <div className="card">
              <div className="body">
                <div className="input-group mb-4 d-flex justify-content-end">
                  <input
                    type="text"
                    className="form-control mr-3"
                    placeholder="Enter Mobile No."
                    value={mobileNo}
                    onChange={(e) => setMobileNo(e.target.value)}
                  />

                  <input
                    type="text"
                    className="form-control  mr-5"
                    placeholder="Enter Kiosk ID"
                    value={kioskId}
                    onChange={(e) => setKioskId(e.target.value)}
                  />
                  <div className=" w-fit">
                    <DatePicker
                      className="form-control text-center"
                      selected={startDate}
                      maxDate={endDate}
                      onChange={setStartDate}
                    />
                  </div>
                  <label className="mx-2 mt-2">to</label>
                  <div className=" w-fit">
                    <DatePicker
                      className="form-control text-center"
                      selected={endDate}
                      minDate={startDate}
                      onChange={setEndDate}
                    />
                  </div>
                </div>
                <MUIDataTable
                  title={
                    isLoading ? (
                      <CircularProgress size={20} />
                    ) : (
                      <p className="my-0">{`${count || 0} records.`}</p>
                    )
                  }
                  data={list}
                  columns={columns}
                  options={options}
                  className="text-center-table"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionWiseDashboard;
